export default "__VITE_ASSET__4a82ff79__"